module.exports = __webpack_public_path__ + "static/media/free-underline-pink.2402adbe.svg";